// Build the URL for a static image served from `public/images/<size>/`.
// `size` is the folder name (pixel dimension), `fileName` is the file at that scale.
export type ImageSize = 140 | 470;

export const buildImageUrl = (size: ImageSize, fileName: string): string =>
  `${process.env.BASE_URL}images/${size}/${fileName}`;
